import { RouterProvider } from 'react-router-dom';

// project-imports
import router from 'routes';
import { AuthProvider } from 'context/AuthContext';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

function App() {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  );
}

export default App;
